module.exports = "/_next/static/images/apple-touch-icon-120-79ccd1baf335aa69a080877e06aeaff5.png";